import * as Yup from 'yup';

import i18n from '@/i18n';

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .max(300, i18n.t('emailValidation', { ns: 'common' }))
    .email(i18n.t('invalidEmail', { ns: 'common' }))
    .required(i18n.t('emailRequired', { ns: 'common' }))
});
